import React from 'react'
import { Button, Spin, Typography } from 'antd'
import { ExportOutlined } from '@ant-design/icons'
import { getOrderPath } from 'routing/utils/getOrderPath'
import styles from './OrderModal.module.scss'

interface IOrderModalTitleProps {
  orderId: string
  number: number | string
  style?: React.CSSProperties
}

export const OrderModalTitle: React.FC<IOrderModalTitleProps> = ({ orderId, number, style }) => (
  <div className={styles.title} style={style}>
    <Typography.Title level={3} className={styles.titleText}>
      Заказ № {number}
    </Typography.Title>
    <Button
      href={getOrderPath(orderId)}
      target='_blank'
      rel='noopener noreferrer'
      icon={<ExportOutlined />}
    >
      Перейти в заказ
    </Button>
  </div>
)

export const OrderModalLoader: React.FC = () => (
  <div className={styles.loader}>
    <Spin size='large' />
  </div>
)
